import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TimelineLite} from "gsap";

export class SoundPlayer {

    constructor() {}

    public switchTo(music:string, fadeDurationInMs:number = 200):void {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => SlotGame.sound.playAmbience(music));
        tl.add(() => {
            SlotGame.sound.fadeAmbience(0, 0);
            SlotGame.sound.fadeAmbience(1, fadeDurationInMs)
        });
    }
}